module.exports = __webpack_public_path__ + "static/media/photo72.21552125.jpg";